<template>
  <div>
    <div>
      <img class="picture" src="../../assets/pictures/monitor01.jpg" alt="" />
    </div>
    <div class="login_box">
      <el-table :data="warnList" border :header-cell-style="{background: '#01d9f0', color: '#ffffff'}">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="报警内容" prop="AlarmContent"></el-table-column>
        <el-table-column label="报警值" prop="AlarmValue" width="150px"></el-table-column>
        <el-table-column label="报警时间" prop="AlarmTimeConvert" width="210px">
          <template slot-scope="scope">
            {{ scope.row.AlarmTimeConvert }}
          </template>
        </el-table-column>
        <el-table-column label="是否处理" prop="Is_Handle" width="120px"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleAlarm(scope)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeWarn(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 编辑报警信息的会话框 -->
    <el-dialog title="编辑报警信息" :visible.sync="editDialogVisible" width="30%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
        <el-form-item label="报警内容" prop="AlarmContent">
          <el-input v-model="editForm.AlarmContent"></el-input>
        </el-form-item>
        <el-form-item label="报警值" prop="AlarmValue">
          <el-input v-model="editForm.AlarmValue"></el-input>
        </el-form-item>
        <el-form-item label="是否处理" prop="Is_Handle">
          <el-select v-model="editForm.Is_Handle" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editAlarmList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '10',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            // 查询参数对象
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 10
            },
            // 报警数据列表
            warnList: [],
            // 总数据条数
            total: 0,
            // 控制修改信息对话框的显示与隐藏
            editDialogVisible: false,
            // 控制添加信息对话框的显示与隐藏
            addDialogVisible: false,
            // 编辑用户信息的表单
            editForm: {},
            // 修改表单的验证规则对象
            editFormRules: {
                AlarmContent: [
                    { required: true, message: '请输入报警内容', trigger: 'blur' },
                ],
                Is_Handle: [
                    { required: true, message: '请输入是否处理', trigger: 'blur' },
                ]
            },
            // 是否启用
            options: [{
                value: 'Y',
                label: '是'
            }, {
                value: 'N',
                label: '否'
            }],
        }
    },
    created () {
        this.getWarnList()
    },
    methods: {
        // 调用接口获取报警信息
        async getWarnList () {
            const { data: res } = await this.$http.get('/WMS/queryMainAlarmRecord', { params: this.getTypeList })
            console.log(res.data)
            for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].Is_Handle == 'Y') {
                    res.data[i].Is_Handle = '是'
                }
                if (res.data[i].Is_Handle == 'N') {
                    res.data[i].Is_Handle = '否'
                }
            }
            this.warnList = res.data
        },
        // 调用接口删除产品类型
        async removeWarn (scope) {
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/WMS/deleteMainAlarmRecord', params)
            console.log(res)
            this.getWarnList()
        },
        // 展示修改产品的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryMainAlarmRecordID', { params })
            console.log(res.data)
            this.editForm = res.data[0]
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        // 调用接口编辑产品类型
        editAlarmList () {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("AlarmContent", this.editForm.AlarmContent)
                // params.append("AlarmTime", this.editForm.AlarmTime)
                params.append("AlarmValue", this.editForm.AlarmValue)
                params.append("Alarm_ID", this.editForm.Alarm_ID)
                // params.append("CreateTime", this.editForm.CreateTime)
                params.append("ID", this.editForm.ID)
                params.append("Is_Handle", this.editForm.Is_Handle)
                console.log('1213' + params)
                const { data: res } = await this.$http.post('/WMS/updateMainAlarmRecord', params)
                console.log(res)
                if (res !== 1) {
                    return this.$message.error('修改报警内容失败！')
                }
                // 关闭对话框
                this.editDialogVisible = false
                // 刷新数据列表
                this.getWarnList()
                // 提示修改成功
                this.$message.success('修改报警内容成功！')
            })
        },
        // 点击按钮处理报警
        async handleAlarm (scope) {
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('123' + params)
            const { data: res } = await this.$http.post('/WMS/HandlAlarm', params)
            console.log(res)
            if (res !== 1) {
                return this.$message.error('系统异常，处理失败！')
            }
            this.$message.success('处理成功！')
            this.removeWarn(scope)
            this.getWarnList()
        }
    }
}
</script>

<style lang="less" scoped>
.picture {
  background-size: 100% 100%;
  position: fixed;
  width: 100%;
  height: 100%;
}
.login_box {
  width: 80%;
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}
.login_box ::v-deep .el-table {
  /* 表格字体颜色 */
  color: rgb(76, 247, 9);
  /* 表格边框颜色 */
  border: 0.5px solid #fcfcfc00;
  height: 80%;
}

/* 删除表格下横线 */
.login_box ::v-deep .el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
.login_box ::v-deep .el-table--fit {
  padding: 20px;
}
.login_box ::v-deep .el-table,
.el-table__expanded-cell {
  background-color: transparent;
}

.login_box ::v-deep .el-table tr {
  background-color: transparent !important;
}
.login_box ::v-deep .el-table--enable-row-transition .el-table__body td,
.el-table .cell {
  background-color: transparent;
}
</style>


